import React from 'react';

import { FormSpy, useForm } from 'react-final-form';

export const FormUpdateWatcher = ({ onUpdate }) => {
  const form = useForm();

  return (
    <FormSpy
      subscription={{ values: true, hasValidationErrors: true, pristine: true, submitting: true }}
      onChange={(state) => {
        const { values, hasValidationErrors, pristine, submitting } = state;

        // https://github.com/final-form/react-final-form/issues/809#issuecomment-808942373
        setTimeout(() => {
          onUpdate({ values, hasValidationErrors, pristine, submitting, form });
        }, 0);
      }}
    />
  );
};
